import React, { useCallback } from 'react'
import { useFieldArray } from 'react-hook-form'
import {
  text,
  button,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { ruleTriggers, ruleTriggersParemetersSectionTitles } from './data'
import Trigger from '../../Trigger'

export default React.memo(({ control, trigger, setValue }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'triggers',
    // default keyName is 'id', which overrides and removes our ids
    // before submit, to prevent that we set it to 'key' and
    // let useFieldArray handles it by itself
    keyName: 'key',
  })
  const onAdd = useCallback(
    () => {
      // Don't add key value for new entity, useFieldArray will add it
      // so the form won't be dirty if only the key is different
      const newEntity = {
        type: null,
        settings: {},
      }
      append(newEntity)
    },
    [append]
  )

  const onRemove = useCallback(
    (action, index) => {
      remove(index)
    },
    [remove]
  )

  const onChange = useCallback(
    (newEntity, index) => {
      setValue(`triggers.${index}`, newEntity, {
        shouldDirty: true,
        shouldValidate: true,
      })
      trigger(`triggers.${index}`)
    },
    [setValue, trigger]
  )

  return (
    <>
      <div>
        {fields.map((item, index) => {
          const { id, key } = item
          return (
            <Trigger
              control={control}
              name={`triggers.${index}`}
              key={`trigger-${id}-${key}`}
              variables={ruleTriggers}
              parameterSectionTitles={ruleTriggersParemetersSectionTitles}
              index={index}
              onRemoveTrigger={onRemove}
              onTriggerChange={onChange}
              onInput={onChange}
              totalTriggers={fields.length}
              placeholder="Select a trigger..."
            />
          )
        })}
      </div>
      <div className="grui mt-10">
        <button
          type="button"
          css={[
            button.styles.link,
            text.styles.textXs,
            text.styles.textPrimary,
          ]}
          onClick={onAdd}
        >
          + Add trigger
        </button>
      </div>
    </>
  )
})
